// extracted by mini-css-extract-plugin
module.exports = {"styledChip":"Uc9Q9faZ"};